import { render } from "./VideoSlider.vue?vue&type=template&id=eee860ae&scoped=true"
import script from "./VideoSlider.vue?vue&type=script&lang=js"
export * from "./VideoSlider.vue?vue&type=script&lang=js"

import "./VideoSlider.vue?vue&type=style&index=0&id=eee860ae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eee860ae"]])

export default __exports__